import { useContext } from "react";
import { Link } from "react-router-dom";
import Context from "../context/UserContext";

export default function NavbarVolver() {
  const { usuario } = useContext(Context);

  return (
    <nav className="bg-gradient-to-r from-pons-500 via-pons-600 to-pons-500 shadow-nav sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-3">
            <a href="/home">
              <img src="logo-pons.png" alt="Logo" className="h-10" />
            </a>
          </div>

          <div className="flex items-center gap-4">
            <Link
              to="/home"
              className="text-white/90 hover:text-pons-300 hover:bg-white/10 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200"
            >
              Volver Al Inicio
            </Link>
            <span className="hidden sm:block text-white/80 text-sm font-medium">
              {usuario}
            </span>
          </div>
        </div>
      </div>
    </nav>
  );
}
